import Filter from '@/src/components/organism/Filter';
import { useEffect, useRef, useState } from 'react';
import { entryFilters } from './filter';
import { useQuery } from '@tanstack/react-query';
import useQueryValues from '@/src/hooks/useQueryValues';
import MainContentTitle from '@/src/components/molecule/MainContentTitle';
import { AgGridReact } from 'ag-grid-react';
import Table from '@/src/components/atom/Table';
import { entryListColumn } from './column';
import SectionCardNoneTitle from '@/src/components/molecule/SectionCardNoneTitle';
import Typo from '@/src/components/atom/Typo';
import Button from '@/src/components/atom/Button';
import LucideIcon from '@/src/components/atom/Icons/LucideIcon';
import usePaginationQuery from '@/src/hooks/usePaginationQuery';
import { NAV_CONST } from '@/src/constants/nav';
import { Link, useNavigate } from 'react-router-dom';
import PATH from '@/src/routes/path';
import { getEntriesAPI, getEntriesExcelAPI } from '@/src/apis/rest/entry';
import ExcelDownloadButton from '@/src/components/atom/ExcelDownloadButton';

export default function EntryListPage() {
  const navigate = useNavigate();

  const { defaultValues } = useQueryValues({
    createdAt: ['createdAtFrom', 'createdAtTo'],
    startedAt: ['startedAtFrom', 'startedAtTo'],
  });
  const { page, pageSize, handlePageChange } = usePaginationQuery();

  const gridRef = useRef<AgGridReact>(null);
  const [values, setValues] = useState(defaultValues);

  const {
    data: entryListOrigin,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ['entries', values, page, pageSize],
    queryFn: () => {
      return getEntriesAPI({
        ...values,
        page,
        pageSize,
      });
    },
  });

  useEffect(() => {
    if (isFetching && gridRef.current) {
      gridRef.current.api?.showLoadingOverlay();
    }
  }, [isFetching]);

  return (
    <>
      <MainContentTitle
        pageTitle={NAV_CONST.entryManagement}
        breadcrumbList={[NAV_CONST.entryManagement]}
      />
      <div className="mb-20 flex flex-col gap-6">
        <Filter
          title="검색 필터"
          filters={entryFilters()}
          onSubmit={values => {
            handlePageChange(1, pageSize, false);
            setValues(values);
          }}
        />
        <div className="flex flex-col gap-y-6">
          <SectionCardNoneTitle
            contentProps={{
              className: 'flex flex-col gap-y-4',
            }}
          >
            <div className="flex items-center justify-between">
              <Typo typoType="b18m">응모하기 목록</Typo>
              <div className="flex gap-2">
                <ExcelDownloadButton
                  disabled={
                    isError || isFetching || !entryListOrigin?.rows?.length
                  }
                  fileName="응모하기_리스트"
                  downloadExcelAPI={getEntriesExcelAPI}
                  searchParams={values}
                />
                <Link to={PATH.ENTRY_CREATE}>
                  <Button buttonSize="medium" onClick={() => {}}>
                    <div className="flex items-center gap-x-2">
                      <LucideIcon name="Plus" color="white" />
                      응모하기 등록
                    </div>
                  </Button>
                </Link>
              </div>
            </div>

            <Table
              ref={gridRef}
              rowData={isError ? [] : entryListOrigin?.rows || []}
              isPaginationDataMapping
              columnDefs={entryListColumn(e => {
                navigate(PATH.ENTRY_DETAIL.replace(':id', String(e)));
              })}
              total={entryListOrigin?.count || 0}
              page={page}
              pageSize={pageSize}
              handlePaginationClick={handlePageChange}
            />
          </SectionCardNoneTitle>
        </div>
      </div>
    </>
  );
}
